export function diffInDays(timestamp: string | number) {
  const diffInMs =
    Date.now() -
    (typeof timestamp === 'number' ? timestamp : parseInt(timestamp))
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24))
}

export function elapsedTime(timestamp: number) {
  const diffInMs = Date.now() - timestamp

  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
  if (diffInDays > 0) {
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
  }

  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
  return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
}
